import type * as React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { ordinalFormat } from '@common/utils/stringUtils';
import DetailsCard from '@rental-manager/components/DetailsCard';
import type { IFeaturePermissionObject } from '@rental-manager/models/Types';

interface Props {
  rentTerms: { tenantOnBoarded: boolean; dueLastDayOfMonth: boolean; monthlyPaymentDate: string };
  rentTermsExtendPermission: IFeaturePermissionObject;
  goToEditDueDatePage: (rentTerms: Record<string, any>) => void;
}

const MonthlyDate: React.FC<React.PropsWithChildren<Props>> = (props: Props): any => {
  const goToEditPage = () => {
    const { goToEditDueDatePage, rentTerms } = props;
    goToEditDueDatePage(rentTerms);
  };
  const { tenantOnBoarded, monthlyPaymentDate, dueLastDayOfMonth } = props.rentTerms;

  const formattedDay = dueLastDayOfMonth ? 'Last day' : ordinalFormat(Number(monthlyPaymentDate));
  const isRentTermsExtendAllowed = props.rentTermsExtendPermission.isAllowed;
  return (
    <DetailsCard
      title="Monthly payment date"
      onEdit={goToEditPage}
      showEdit={!tenantOnBoarded}
      editingDisabled={!isRentTermsExtendAllowed}
    >
      <Text>{formattedDay} of the month</Text>
    </DetailsCard>
  );
};
export default MonthlyDate;
